import React from 'react';
import { RecentDropsPage } from '@components/RecentsDrops';
import { Seo } from '@components/Seo';

export default function Recent() {
  return (
    <>
      <Seo title="Recent Drops | Sound.xyz" />
      <div className="w-full bg-white pb-12 md:pb-16">
        <RecentDropsPage />
      </div>
    </>
  );
}
